import { render, staticRenderFns } from "./comYuan.vue?vue&type=template&id=e3d48170&scoped=true&"
import script from "./comYuan.vue?vue&type=script&lang=js&"
export * from "./comYuan.vue?vue&type=script&lang=js&"
import style0 from "./comYuan.vue?vue&type=style&index=0&id=e3d48170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3d48170",
  null
  
)

export default component.exports